module.exports = __webpack_public_path__ + "files/ce2f4f364c05cc5549270ab85b379dc2.svg";